
import menu from './menu'
import request from '../request'
//eslint-disable-next-line
let valid = (params)=>{
    if (params['id'] == null || params['id'] == -1){
        return ''
    }else {
        return `${params['id']}/`
    }
}
export default {
    media_url : 'https://triplefireman.com/media',
    base_url : 'https://triplefireman.com/',
    menu,
    get : 'GET',
    post : 'POST', 
    put : 'PUT',
    delete : 'DELETE',
    patch : 'PATCH',
    partner : (method = 'get', params) => request.req(`SportRecord/api/partner/${valid(params)}`,method, params),
    partner_bulk_delete : (method = 'delete', params) => request.req(`SportRecord/api/partner/bulk-delete/`,method, params),
    sendVip:(method='post',params) => request.req('SportRecord/api/users/sendVip/',method,params),
    sendYearVip:(method='post',params) => request.req('SportRecord/api/users/sendVip/',method,{ ...params, vip_type: 'yearly' }),
    record : (method = 'get', params) => request.req(`SportRecord/api/record/${valid(params)}`,method, params),
    place : (method = 'get', params) => request.req(`SportRecord/api/place/${valid(params)}`,method, params),
    users : (method = 'get', params,data) => request.req(`SportRecord/api/users/${valid(params)}`,method, params,data),
    users_grant_role : (method = 'get', params) => request.req(`SportRecord/api/users/${valid(params)}/grant-role/`,method, params),
    users_bulk_delete : (method = 'delete', params) => request.req(`SportRecord/api/users/bulk-delete/`,method, params),
    users_update_pwd : (method = 'delete', params) => request.req(`SportRecord/api/users/${valid(params)}/update-pwd/`,method, params),
    role : (method = 'get', params) => request.req(`SportRecord/api/role/${valid(params)}`,method, params),
    role_bulk_delete : (method = 'delete', params) => request.req(`SportRecord/api/role/bulk-delete/`,method, params),
    property: (method = 'get', params, formData, isFile = false) => request.req(`SportRecord/api/property/${valid(params)}`,method, params,formData, isFile),
    clothing : (method = 'get', params) => request.req(`SportRecord/api/clothing/${valid(params)}`,method, params),
    menus : (method = 'get', params) => request.req(`SportRecord/api/menu/${valid(params)}`,method, params),
    category : (method = 'get', params) => request.req(`SportRecord/api/category/${valid(params)}`,method, params),
    unregister : (method = 'get', params) => request.req(`SportRecord/api/unregister/${valid(params)}`,method, params),
    unregister_delete :  (method = 'delete', params) => request.req(`SportRecord/api/unregister/delAction/`,method, params),
    feedbacks : (method = 'get', params) => request.req(`SportRecord/api/feedbacks/${valid(params)}`,method, params),
}
